import React, { useEffect, FC, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Globle } from "hooks/Globle";
import Cookies from "js-cookie";
import $ from "jquery";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import moment from 'moment';
import { useLocation } from 'react-router-dom';

import Textarea from "shared/Textarea/Textarea";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Banner from "components/SectionHero/Banner";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import FormItem from "components/FormItem";
import Select from "shared/Select/Select";
import Input from "shared/Input/Input";
import axios from "axios";
import Checkbox from "shared/Checkbox/Checkbox";

interface DataList {
  collection: object,
  collection_date: string,
  collection_postcode: string,
  delivery_date: string,
  delivery_postcode: string,
  discount_price: number,
  delivery_services: any,
  price: number,
  optionals: any,
  product: object,
  slot: string,
  vat: number,
  total: number,
  weight: number,
}
interface SettingList {
  collection_service_type: any,
  commission: any,
  delivery_service_type: any,
  discount: any,
  unique_postcode: any,
}

const CheckOutAddress: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [collectionAddress, setCollectionAddress] = useState([]);
    const [deliveryAddress, setDeliveryAddress] = useState([]);
    const [data, setData] = useState<DataList>();
    const [pallet, setPallet] = useState([]);
    const [setting, setSetting] = useState<SettingList | any>();
    const [open, setOpen] = useState(false)
    const [engineOpen, setEngineOpen] = useState(false)
    const [billingAsCustom, setBillingAsCustom] = useState(false)
    const [proc, setProc] = useState(false);
    
    const { apiPath, convertToObject } = Globle();
    const userSession = Cookies.get("userSession");

    const loadCheckoutSession = () => {
        axios
            .get(apiPath + "api/checkout-address?sessionId=" + userSession)
            .then((response) => {
                if (response.status == 200) {
                    const dataResp = response.data as {
                        errors: any;
                        data: any;
                        success: boolean;
                        pallets: [],
                        setting: {},
                        collectAddress: [],
                        deliveryAddress: [],
                    };

                    if (
                        dataResp.success == false &&
                        typeof dataResp.errors != undefined
                    ) {
                        navigate("/");
                    }


                    if (dataResp.success == true) {
                        console.log(dataResp);
                        setData(dataResp.data);
                        setPallet(dataResp.pallets);
                        setSetting(dataResp.setting);
                        setCollectionAddress(dataResp.collectAddress);
                        setDeliveryAddress(dataResp.deliveryAddress);
                    }
                } else {
                    toast.error("Something went wrong, Please Try Again!");
                }
            })
            .catch((error) => console.error("Error adding user:", error));
    };

    const fetchSessionData = async () => {
      try {
        const response:any = await axios.get(apiPath+'api/session');
        Cookies.set('userSession', response.data);
      } catch (err) {
        toast.error("Something went wrong, Please Try Again!");
      } finally {
  
      }
    };

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const userBookingCheckoutSessionId = params.get('session_id');
      const mode:any = params.get('mode');
      
      
      if (userBookingCheckoutSessionId) {
        setProc(true);
        confirmBooking(userBookingCheckoutSessionId, mode);
      }
    }, [location.search]);

    const confirmBooking = (userBookingCheckoutSessionId:string, mode:string) => {
      console.log(mode);
      axios
      .post(apiPath + "api/confirm-booking?session_id=" + userBookingCheckoutSessionId + '&mode='+mode)
      .then((response) => {
          if (response.status == 200) {
              const dataResp = response.data as {
                  errors: any;
                  error: any;
                  order_id: any;
                  success: boolean;
              };

              if (dataResp.success == false && typeof dataResp.errors != undefined){
                  // navigate("/");
              }

              if (dataResp.success == true) {
                Cookies.set('userBookingOrderId', dataResp.order_id);
                Cookies.set('userBookingCheckoutSessionId', userBookingCheckoutSessionId);
                fetchSessionData();
                navigate("/thankyou");
              }

          } else {
              toast.error("Something went wrong, Please Try Again!");
          }
      })
      .catch((error) => console.error("Error adding user:", error));
    };

    const addressDistriut = (event:any) => {
        var type = $(event.target).attr('data-type');
        var val = $(event.target).val();
        if(val!='' && val!=null){
          var v = val.split(', ');
          $('[name="'+type+'[address_line_1]"]').val((v[0]!=undefined)?v[0]:null).trigger('change');
          $('[name="'+type+'[address_line_2]"]').val((v[1]!=undefined)?v[1]:null).trigger('change');
          $('[name="'+type+'[address_line_3]"]').val((v[2]!=undefined)?v[2]:null).trigger('change');
          $('[name="'+type+'[town]"]').val((v[5]!=undefined)?v[5]:null).trigger('change');
          $('[name="'+type+'[county]"]').val((v[6]!=undefined)?v[6]:null).trigger('change');
        }
    }

    const startCheck = () => {
      
      var colmob:any = $('.col-mobno');
      if(colmob.val() != '' && colmob.val() != null){
        if(!$(colmob).val().startsWith('07') && !$(colmob).val().startsWith('7')) {
          $(colmob).attr('required', 'required').addClass('isReq');
        }else{
          $(colmob).removeAttr('required').removeClass('isReq');
        }
      }

      var delmob:any = $('.del-mobno');
      if(delmob.val() != '' && delmob.val() != null){
        if(!$(delmob).val().startsWith('07') && !$(delmob).val().startsWith('7')) {
          $(delmob).attr('required', 'required').addClass('isReq');
        }else{
          $(delmob).removeAttr('required').removeClass('isReq');
        }
      }

      var coltel:any = $('.col-telno');
      if(coltel.val() != '' && coltel.val() != null){
        if($(coltel).val().startsWith('07') || $(coltel).val().startsWith('7')) {
          $(coltel).attr('required', 'required').addClass('isReq');
        }else{
          $(coltel).removeAttr('required').removeClass('isReq');
        }
      }

      var deltel:any = $('.del-telno');
      if(deltel.val() != '' && deltel.val() != null){
        if($(deltel).val().startsWith('07') || $(deltel).val().startsWith('7')) {
          $(deltel).attr('required', 'required').addClass('isReq');
        }else{
          $(deltel).removeAttr('required').removeClass('isReq');
        }
      }
    }

    const numberCheck = (event : any) => {
      
      var collect_val:any = true;
      $('.collect-number').each(function(k, v) {
        if($(v).val() != '' && $(v).val() != null){
          collect_val = false;
        }
      });
      // $('.delivery-number').trigger('change');
      if(collect_val == false){
        $('.collect-number').removeAttr('required').removeClass('isReq');
      }else{
        $('.collect-number').attr('required', 'required').addClass('isReq');
      }
      
      var delivery_val:any = true;
      $('.delivery-number').each(function(k, v) {
        if($(v).val() != '' && $(v).val() != null){
          delivery_val = false;
        }
      });
      // $('.collect-number').trigger('change');
      if(delivery_val == false){
        $('.delivery-number').removeAttr('required').removeClass('isReq');
      }else{
        $('.delivery-number').attr('required', 'required').addClass('isReq');
      }

      startCheck();
      
      var val:any = $(event.target).val();
			var valid:any = $(event.target).attr('data-valid');
			if(val.length > valid){
				$(event.target).val(val.slice(0,valid));
				return false;
			}
    }

    const handleErrors = (errors: { [key: string]: string[] }) => {
        Object.keys(errors).forEach(key => {
            const errorMessages = errors[key];
            errorMessages.forEach(message => {
            toast.error(message);
            });
        });
    };

    const handleSubmit = async (event:any) => {
        event.preventDefault();

        var retFal = false;
        $(event.target).find('[required].isReq').each(function(k, v) {
          if($(v).hasClass('col-mobno') || $(v).hasClass('del-mobno') || $(v).hasClass('col-telno') || $(v).hasClass('del-telno')){
            $(v)[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            retFal = true;
          }
        });


        if(retFal){
          return false;
        }



        $(event.target).find('input[name="sessionId"]').val(userSession ?? '');
        const inputArray = $(event.target).serializeArray();
        const data = convertToObject(inputArray);

        var btn = $(event.target).find('[type="submit"]').html();
        $(event.target).find('[type="submit"]').attr('disabled', 'disabled');
        $(event.target).find('[type="submit"]').html('Redirecting...');
    
        await axios.post(apiPath+'api/store-submittion', data).then(response => {
    
          if(response.status == 200){
            const dataResp = response.data as {errors: any;success: boolean, error:any, redirect:any, order_id:any};

            // console.log(dataResp);
            
            if(dataResp.success == false && typeof dataResp.errors != undefined && Array.isArray(dataResp.errors)){
                dataResp.errors.map((item: string) => toast.error(item));
            }else if(dataResp.success == false && typeof dataResp.errors != undefined){
                handleErrors(dataResp.errors);
            }else if(dataResp.success == false && dataResp.error){
                toast.error(dataResp.error);
            }
    
            if(dataResp.success == true){
                Cookies.set('userBookingRedirectLink', dataResp.order_id);
                window.location.href = dataResp.redirect;
            }else{
              $(event.target).find('[type="submit"]').html(btn);
              $(event.target).find('[type="submit"]').removeAttr('disabled');
            }
            
            
          }else{
            $(event.target).find('[type="submit"]').html(btn);
            toast.error("Something went wrong, Please Try Again!");
          }
    
        }).catch(error => {
          console.error('Error adding user:', error)
          $(event.target).find('[type="submit"]').html(btn);
          $(event.target).find('[type="submit"]').removeAttr('disabled');
        });
    }

    useEffect(() => {
        loadCheckoutSession();

        $(document).on('change keyup', '[required]', function(){
          var _this = $(this);
          if(_this.val() == '' || _this.val() == null){
            $(_this).addClass('isReq');            
          }else{
            $(_this).removeClass('isReq');
          }

          startCheck();
        })
    }, []);

    return (
        <>
            <style>
              {`
                [required].isReq {
                    animation-name: required;
                    animation-duration: 2s;
                    animation-iteration-count: infinite;
                    box-shadow: 0 0 2px 1px #ff4b0054;
                    border:solid 1px #ff4b00a8;
                    margin-bottom:10px;
                    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                }
                @keyframes required {
                    0%   {box-shadow:0 0 0px 0px #ff4b0054;}
                    50%  {box-shadow:0 0 4px 1px #ff4b0054;}
                    100%  {box-shadow:0 0 0px 0px #ff4b0054;}
                }
              `}
            </style>
            <div
                className={`nc-PageAbout overflow-hidden relative `}
                data-nc-id="CheckOut"
            >
                <Helmet>
                    <title>Address | PalletBooking</title>
                </Helmet>

                {/* ======== BG GLASS ======== */}
                {/* <BgGlassmorphism /> */}

                <div className="container mt-16">
                    {(!proc) ? (
                      <Banner
                        heading="Address"
                        btnText=""
                        textClass="text-center"
                      />
                    ) : (
                      <Banner
                        heading="Payment Processing..."
                        btnText=""
                        textClass="text-center"
                      />
                      
                    )}
                </div>
            </div>

            <div className="ListingDetailPage">
                <div className="container ListingDetailPage__content">
                    <div className="nc-ListingStayDetailPage">
                        <main className=" z-10 mt-11">

                          <form onSubmit={handleSubmit} method="POST">
                            <input type="hidden" name="sessionId" />

                            {(!proc) ? (
                              <>
                                <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-12">
                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 border-b py-3 border-t mb-5">
                                            Goods Description
                                        </h2>

                                        <FormItem label="Please let us know what you are sending *">
                                            <Textarea
                                                name="description"
                                                rows={3}
                                                required={true}
                                                className="isReq"
                                            ></Textarea>
                                        </FormItem>

                                        <div className="flex justify-between item-center mt-4">
                                          <FormItem
                                              label="Sending an Engine?"
                                          >
                                            <Checkbox
                                                type="checkbox"
                                                label="Yes, I am sending an engine"
                                                nameId={"engine_transport"}
                                                name="engine_transport"
                                                defaultChecked={false}
                                                className="text-sm font-medium"
                                            />
                                          </FormItem>

                                          <button type="button" onClick={() => setEngineOpen(true)} className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 tnc-Button relative inline-flex items-center justify-center rounded-full transition-colors px-6 h-11 text-sm sm:text-base font-samll"> Explain </button>
                                        </div>
                                    </div>

                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 border-b py-3 border-t mb-5">
                                            Email Address
                                        </h2>
                                        <FormItem
                                            label="Email *"
                                            desc="Email address used for invoices and labels."
                                        >
                                            <Input name="email" placeholder="xyz@gmail.com" type="email" className="isReq" required={true} />
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-12">
                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">
                                            Collection
                                        </h2>

                                        <FormItem label="Please select your collection address">
                                            <Select onChange={addressDistriut} className={`addressDistriut`} name="collect[address]" data-type="collect">
                                              <option value="">Select Address</option>
                                                {collectionAddress && collectionAddress.length > 0 ? collectionAddress.map(
                                                    (item: any, index) => (
                                                        <option key={1000 +index} value={item}> {item} </option>
                                                    )
                                                ) : ""}
                                            </Select>
                                        </FormItem>
                                        
                                        <FormItem
                                          className="mt-4"
                                            label="Collect From *"
                                            desc="Enter company name if commercial"
                                        >
                                            <Input className="mt-1 isReq" type="text" name="collect[address_line_1]" placeholder="Company Name or Adress line 1 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="collect[address_line_2]" placeholder="Adress line 2 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="collect[address_line_3]" placeholder="Adress line 3 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="collect[town]"  placeholder="City/town *"required={true} />
                                            <Input className="mt-1 isReq" type="text" name="collect[county]"  placeholder="County *"required={true} />
                                        </FormItem>

                                        <FormItem
                                          className="mt-4"
                                            label="Postcode"
                                        >
                                          <Input className="bg-gray-100" name="collect[postcode]" value={(data && data.collection_postcode) ? data.collection_postcode : ''} readOnly={true} />
                                        </FormItem>
                                    </div>

                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">
                                            Delivery
                                        </h2>

                                        <FormItem label="Please select your delivery address">
                                            <Select onChange={addressDistriut} name="delivery[address]" data-type="delivery">
                                              <option value="">Select Address</option>
                                                {deliveryAddress && deliveryAddress.length > 0 ? deliveryAddress.map(
                                                    (item: any, index) => (
                                                        <option key={index} value={item}> {item} </option>
                                                    )
                                                ) : ""}
                                            </Select>
                                        </FormItem>
                                        
                                        <FormItem
                                          className="mt-4"
                                            label="Deliver To *"
                                            desc="Enter company name if commercial"
                                        >
                                            <Input className="mt-1 isReq" type="text" name="delivery[address_line_1]" placeholder="Company Name or Adress line 1 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="delivery[address_line_2]" placeholder="Adress line 2 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="delivery[address_line_3]" placeholder="Adress line 3 *" required={true} />
                                            <Input className="mt-1 isReq" type="text" name="delivery[town]"  placeholder="City/town *"required={true} />
                                            <Input className="mt-1 isReq" type="text" name="delivery[county]"  placeholder="County *"required={true} />
                                        </FormItem>

                                        <FormItem
                                          className="mt-4"
                                            label="Postcode"
                                        >
                                          <Input className="bg-gray-100" name="delivery[postcode]" value={(data && data.delivery_postcode) ? data.delivery_postcode : ''} readOnly={true} />
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-12">
                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">
                                          Collection Information:
                                        </h2>
                                        <FormItem
                                            className="mt-4"
                                            label="Mobile No. *"
                                            desc="Enter your UK number (e.g., 07123456789). Must be 10 to 11 digits"
                                        >
                                            <Input badge="+44" onChange={numberCheck} name="collect[phone]" min="999999999" max="99999999999" data-valid="11" placeholder="Enter your UK number" type="number" required={true} className="isReq collect-number col-mobno" />
                                        </FormItem>

                                        <FormItem
                                            className="mt-4"
                                            label="Landline No. *"
                                            desc="Enter your UK number (e.g., 02123456789). Must be 10 to 11 digits"
                                        >
                                            <Input badge="+44" onChange={numberCheck} name="collect[telephone]" min="999999999" max="99999999999" data-valid="11" placeholder="Enter your Landline No." type="number" required={true} className="isReq collect-number col-telno" />
                                        </FormItem>
                                        
                                        <FormItem
                                            className="mt-4"
                                            label="Contact Name"
                                        >
                                            <Input name="collect[name]" placeholder="On-Site Contact Name" type="text"/>
                                        </FormItem>
                                        
                                        <FormItem
                                            className="mt-4"
                                            label="Collection Driver Notes:"
                                            desc="Avoid timed requests"
                                        >
                                            <Textarea name="collect[note]" placeholder="Notes are for driver only, not monitored by support Include access restrictions; no time-sensitive requests.For small vehicle, tick below."></Textarea>
                                        </FormItem>

                                        {(data && data.weight && data.weight*1 <= 750) ? (
                                        <div className="flex justify-between item-center mt-4">
                                          <FormItem
                                              label="Request Small Vehicle"
                                          >
                                            <Checkbox
                                                type="checkbox"
                                                label="Yes, I want small vehicle"
                                                nameId={"collect_small_vehicle"}
                                                name="collect[small_vehicle]"
                                                defaultChecked={false}
                                                className="text-sm font-medium"
                                            />
                                          </FormItem>
      
                                          <button type="button" onClick={() => setOpen(true)} className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 tnc-Button relative inline-flex items-center justify-center rounded-full transition-colors px-6 h-11 text-sm sm:text-base font-samll"> Explain </button>
                                        </div>
                                        ) : ''}
                                    </div>

                                    <div className="listingSection__wrap_x">
                                        <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">
                                          Delivery Information:
                                        </h2>
                                        <FormItem
                                            className="mt-4"
                                            label="Mobile No. *"
                                            desc="Enter your UK number (e.g., 07123456789). Must be 10 to 11 digits"
                                        >
                                            <Input badge="+44" onChange={numberCheck} name="delivery[phone]" min="999999999" max="99999999999" data-valid="11" placeholder="Enter your UK number" type="number" required={true} className="isReq delivery-number del-mobno" />
                                        </FormItem>
                                        
                                        <FormItem
                                            className="mt-4"
                                            label="Landline No. *"
                                            desc="Enter your UK number (e.g., 02123456789). Must be 10 to 11 digits"
                                        >
                                            <Input badge="+44" onChange={numberCheck} name="delivery[telephone]" min="999999999" max="99999999999" data-valid="11" placeholder="Enter your Landline No." type="number" required={true} className="isReq delivery-number del-telno" />
                                        </FormItem>
                                        
                                        <FormItem
                                            className="mt-4"
                                            label="Contact Name"
                                        >
                                            <Input name="delivery[name]" placeholder="On-Site Contact Name" type="text"/>
                                        </FormItem>
                                        
                                        <FormItem
                                            className="mt-4"
                                            label="Delivery Driver Notes:"
                                            desc="Avoid timed requests"
                                        >
                                            <Textarea name="delivery[note]" placeholder="Notes are for driver only, not monitored by support Include access restrictions; no time-sensitive requests.For small vehicle, tick below."></Textarea>
                                        </FormItem>

                                        {(data && data.weight && data.weight*1 <= 750) ? (
                                          <div className="flex justify-between item-center mt-4">
                                            <FormItem
                                                label="Request Small Vehicle"
                                            >
                                              <Checkbox
                                                  type="checkbox"
                                                  label="Yes, I want small vehicle"
                                                  nameId={"delivery_small_vehicle"}
                                                  name="delivery[small_vehicle]"
                                                  defaultChecked={false}
                                                  className="text-sm font-medium"
                                              />
                                            </FormItem>

                                            <button type="button" onClick={() => setOpen(true)} className="ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 tnc-Button relative inline-flex items-center justify-center rounded-full transition-colors px-6 h-11 text-sm sm:text-base font-samll"> Explain </button>
                                          </div>
                                        ) : ''}
                                    </div>
                                </div>

                                <div className="mt-2 grid grid-cols-1 sm:grid-cols-1 gap-12">
                                  <div className="listingSection__wrap_x">
                                    <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">Billing Information</h2>
                                    <FormItem
                                        label="Set your billing address save as"
                                        className=" mb-2"
                                    >
                                      <div className="flex justify-start mt-2">
                                        <div className="">
                                          <Checkbox
                                              type="radio"
                                              label="Collection"
                                              nameId={"billAddress_collect"}
                                              name="billing_same_as"
                                              defaultChecked={true}
                                              value="collect"
                                              className=" text-sm font-medium"
                                              onChange={() => setBillingAsCustom(false)}
                                          />
                                        </div>
                                        
                                        <div className="ml-5">
                                        <Checkbox
                                            type="radio"
                                            label="Delivery"
                                            nameId={"billAddress_delivery"}
                                            name="billing_same_as"
                                            defaultChecked={false}
                                            value="delivery"
                                            className="text-sm font-medium"
                                            onChange={() => setBillingAsCustom(false)}
                                        />
                                        </div>
                                        
                                        <div className="ml-5">
                                        <Checkbox
                                            type="radio"
                                            label="Custom"
                                            nameId={"billAddress_custom"}
                                            name="billing_same_as"
                                            defaultChecked={false}
                                            value="custom"
                                            className="text-sm font-medium"
                                            onChange={() => setBillingAsCustom(true)}
                                        />
                                        </div>
                                      </div>
                                    </FormItem>

                                    {(billingAsCustom) ? (

                                      <>
                                        <h2 className="text-1xl font-semibold mb-1 mt-5">Enter your custom billing address</h2>

                                        <div className="mt-2 grid grid-cols-3 sm:grid-cols-3 gap-3">
                                          <FormItem
                                            className="mt-2"
                                            label="Address Line 1"
                                          >
                                              <Input name="bill[address_line_1]" placeholder="Company Name or Adress line 1" type="text"/>
                                          </FormItem>

                                          <FormItem
                                            className="mt-2"
                                            label="Address Line 2"
                                          >
                                              <Input name="bill[address_line_2]" placeholder="Company Name or Adress line 2" type="text"/>
                                          </FormItem>

                                          <FormItem
                                            className="mt-2"
                                            label="Address Line 3"
                                          >
                                              <Input name="bill[address_line_3]" placeholder="Company Name or Adress line 3" type="text"/>
                                          </FormItem>
                                          
                                          <FormItem
                                            className="mt-2"
                                            label="Town"
                                          >
                                              <Input name="bill[town]" placeholder="City/town" type="text"/>
                                          </FormItem>

                                          <FormItem
                                            className="mt-2"
                                            label="Country"
                                          >
                                              <Input name="bill[county]" placeholder="County" type="text"/>
                                          </FormItem>
                                        </div>
                                      </>
                                    
                                    ) : ('')}
                                  </div>
                                </div>
                              </>
                            ) : ('')}

                            <div className="mt-2 grid grid-cols-1 sm:grid-cols-1 gap-12">
                              <div className="listingSection__wrap_x">
                                <h2 className="text-2xl font-semibold mb-3 mt-5 border-b py-3 border-t mb-5">Checkout Summary</h2>
                                  
                                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                            <tr>
                                                <th scope="col" className="px-6 py-3">
                                                  Dates & PostCode
                                                </th>
                                                <th scope="col" className="px-6 py-3">
                                                  Pallets
                                                </th>
                                                <th scope="col" className="px-6 py-3">
                                                  Description
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-right">
                                                  Units
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-right">
                                                  Price
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          {pallet && pallet.length > 0 ? (
                                            pallet.map((item:any, index:number) => (
                                              <tr key={99+index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                                  <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                    {(item.type == 'collect') ? (
                                                      <>
                                                        Collection - {item.postcode} <br />
                                                        {data && data.collection_date ? moment(data.collection_date).format('Do MMM YYYY') : null}
                                                      </>
                                                    ) : (
                                                      <>
                                                        Delivery - {item.postcode} <br />
                                                        {data && data.delivery_date ? moment(data.delivery_date).format('Do MMM YYYY') : null}
                                                      </>
                                                    )}
                                                  </th>
                                                  <td className="px-6 py-4">
                                                    {item.name} Pallet
                                                  </td>
                                                  <td className="px-6 py-4">
                                                    {item.detail.description_line1} <br />
                                                    {item.detail.description_line2}
                                                  </td>
                                                  <td className="px-6 py-4 text-right">
                                                    x {item.qty}
                                                  </td>
                                                  <td className="px-6 py-4 text-right font-normal">
                                                    £{item.price}
                                                  </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                              <td className="px-6 py-4 text-center" colSpan={5}> No Pallet Found </td>
                                            </tr>
                                          )}

                                          {data && data.delivery_services && data.delivery_services.delivery_option_id ? (
                                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                  Delivery Service
                                                </th>
                                                <td className="px-6 py-4">
                                                  {data.delivery_services.delivery_option_name ?? null}
                                                </td>
                                                <td className="px-6 py-4">
                                                  {data.delivery_services.delivery_option_description ?? null}
                                                </td>
                                                <td className="px-6 py-4 text-right">
                                                </td>
                                                <td className="px-6 py-4 text-right font-normal">
                                                  £{data.delivery_services.delivery_option_price ?? null}
                                                </td>
                                            </tr>
                                          ) : ('')}

                                          {data && data.optionals && data.optionals.length > 0 ? (
                                            data.optionals.map((item:any, index:number) => (
                                              <tr key={199+index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                                  <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                   {item.collection_option_name} <i className="text-xs text-gray-900 font-normal">Optional</i>
                                                  </th>
                                                  <td className="px-6 py-4" colSpan={3}>
                                                    {item.collection_option_description}
                                                  </td>
                                                  <td className="px-6 py-4 text-right font-normal">
                                                    £{item.collection_option_price}
                                                  </td>
                                              </tr>
                                            ))
                                          ) : ('')}

                                          {data && data.discount_price && data.discount_price > 0 ? (
                                            <tr>
                                              <th scope="col" colSpan={4} className=" py-3 text-right">
                                                Discount Applied ({setting && setting.discount ? setting.discount : 0}% Off)
                                              </th>
                                              <th scope="col" className="px-6 py-3 text-right text-red-800 font-normal">
                                                -£{data.discount_price}
                                              </th>
                                            </tr>
                                          ) : ('')}

                                          {data && data.vat && data.vat > 0 ? (
                                            <tr>
                                              <th scope="col" colSpan={4} className=" py-3 text-right">
                                                Vat
                                              </th>
                                              <th scope="col" className="px-6 py-3 text-right font-normal">
                                                +£{data.vat.toFixed(2)}
                                              </th>
                                            </tr>
                                          ) : ('')}

                                          {data && data.total && data.total > 0 ? (
                                            <tr>
                                              <th scope="col" colSpan={4} className=" py-3 text-right">
                                                Total
                                              </th>
                                              <th scope="col" className="px-6 py-3 text-right">
                                                +£{data.total.toFixed(2)}
                                              </th>
                                            </tr>
                                          ) : ('')}
                                        </tbody>
                                    </table>
                                </div>
                              </div>
                            </div>
                            
                            {(!proc) ? (
                              <div className="flex justify-center mt-20">
                                <div className="listingSection__wrap_x w-2/3">
                                  <p className="text-1xl font-semibold mb-3 mt-5">Fill all required fields with an orange border to continue.</p>
                                  
                                  <FormItem>
                                      <Checkbox 
                                        type="checkbox"
                                        label="Terms"
                                        nameId={'accept'}
                                        defaultChecked={false}
                                        className="text-sm font-medium" 
                                        name="accept"
                                        required={true}
                                      />
                                  </FormItem>

                                  <button type="submit" className="w-full mt-5 ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50 tnc-Button relative inline-flex items-center justify-center rounded-full transition-colors px-6 h-11 text-sm sm:text-base font-samll"> 
                                    <span className="mr-3">Continue CheckOut</span> 
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            ) : ('')}
                          </form>

                        </main>
                    </div>
                </div>

                <div className="container py-6 mb-10">
                    {/* <SectionSubscribe2 className="pt-24" /> */}
                </div>
            </div>

            <Dialog open={open} onClose={setOpen} className="relative z-[60]">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 lg:max-w-3xl"
                  >
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <div className="flex justify-between items-center  mb-4">
                            <DialogTitle as="h3" className="text-2xl font-semibold leading-6 text-gray-900">
                              SMALL VEHICLE EXPLAINED
                            </DialogTitle>
                            <span onClick={() => setOpen(false)} className="cursor-pointer"> 
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                              </svg>
                            </span>
                          </div>
                          <div className="flex justify-between">
                              <div className="flex items-center justify-center max-w-[280px]" style={{flex:"0 0 200px"}}>
                                <img src={`images/truck.png`} className="" />
                              </div>
                              <div>
                                <div className="mt-2">
                                  <h3 className="text-large font-semibold leading-6 text-gray-900">When we mention a 'small vehicle', we typically refer to a 7.5 tonne truck.</h3>  
                                  <p className="text-sm text-gray-500">
                                  Unsure if you need a small vehicle? A good rule of thumb is to consider if a rubbish collection lorry struggles with access to your location - our larger vehicles will face the same challenge. To prevent any difficulties, it's advisable to opt for this complimentary service when you suspect it might be needed.

                                  Please bear in mind, though we strive to deliver top-notch service, the availability of small vehicles within pallet networks is limited. This can occasionally impact the delivery dates if a small vehicle isn't available on your chosen day.
                                  </p>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            <Dialog open={engineOpen} onClose={setEngineOpen} className="relative z-[60]">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center px-4 py-5 text-center">
                  <DialogPanel
                    transition
                    className="relative flex max-h-[calc(100vh-40px)] w-full transform flex-col overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 lg:max-w-4xl"
                  >
                    <button
                      type="button"
                      onClick={() => setEngineOpen(false)}
                      aria-label="Close"
                      className="absolute right-4 top-4 z-20 flex h-9 w-9 items-center justify-center rounded-full border border-[#c7d2e8] bg-white text-[#14265c] hover:bg-neutral-100"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-5 w-5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                      </svg>
                    </button>

                    <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">

                    {/* Header: crated engine + the rule itself */}
                    <div className="grid grid-cols-1 gap-6 border-b border-neutral-200 px-6 py-8 sm:px-8 md:grid-cols-2 md:gap-8">
                      <div className="flex items-center justify-center">
                        <img
                          src="/images/engine-crated.jpg"
                          alt="Engine secured inside a wooden transport crate on a pallet"
                          className="w-full max-w-[420px] rounded-lg"
                        />
                      </div>

                      <div>
                        <DialogTitle as="h3" className="text-3xl font-extrabold leading-tight text-[#14265c] sm:text-4xl">
                          Engine Transport
                        </DialogTitle>
                        <p className="mt-1 text-lg font-semibold uppercase tracking-wide text-[#1d4ed8]">
                          Important Guidelines
                        </p>
                        <span className="mt-3 block h-1 w-16 rounded bg-[#2563eb]"></span>

                        <p className="mt-5 text-base leading-relaxed text-neutral-700">
                          Used engines will only be accepted if they are contained within a suitable crate, stillage, or purpose-built transport frame.
                        </p>

                        <div className="mt-5 flex items-start gap-3 rounded-lg bg-[#fdeaea] p-4">
                          <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-[#d61f26] text-sm font-bold text-white">!</span>
                          <p className="text-sm leading-relaxed text-neutral-800">
                            Engines placed directly on pallets are no longer accepted under any circumstances.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Requirements vs prohibitions */}
                    <div className="grid grid-cols-1 gap-8 px-6 py-8 sm:px-8 md:grid-cols-2">
                      <div className="md:border-r md:border-neutral-200 md:pr-8">
                        <h4 className="text-sm font-bold uppercase tracking-wide text-[#14265c]">
                          Requirements for engine transport
                        </h4>
                        <p className="mt-2 text-sm text-neutral-700">The crate, stillage, or frame must:</p>

                        <ul className="mt-4 space-y-3">
                          {[
                            { d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z", t: "Be strong enough for the engine's weight and size." },
                            { d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244", t: "Prevent movement during transit." },
                            { d: "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12", t: "Be suitable for forklift handling." },
                            { d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9", t: "Protect both the engine and other freight from damage." },
                          ].map((item, i) => (
                            <li key={i} className="flex items-center gap-4 rounded-xl border border-neutral-200 p-3">
                              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-[#eef2fb] text-[#14265c]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                                  <path strokeLinecap="round" strokeLinejoin="round" d={item.d} />
                                </svg>
                              </span>
                              <span className="text-sm leading-relaxed text-neutral-800">{item.t}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div>
                        <h4 className="text-sm font-bold uppercase tracking-wide text-[#d61f26]">
                          The following are not allowed:
                        </h4>

                        <div className="mt-4 space-y-4">
                          {[
                            { img: "/images/engine-no-crate.jpg", alt: "Engine sitting directly on a bare pallet", t: "Engines on pallets without a crate/stillage/frame." },
                            { img: "/images/engine-wrapped.jpg", alt: "Engine secured only with shrink wrap", t: "Using rope, tape, stretch wrap, or shrink wrap as the primary securing method." },
                          ].map((item, i) => (
                            <div key={i} className="relative flex items-center gap-3 rounded-xl bg-[#fdeaea] p-4">
                              <span className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-[#d61f26] text-white shadow">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="h-4 w-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                              </span>
                              <span className="flex-none text-[#d61f26]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-7 w-7">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
                                </svg>
                              </span>
                              <p className="flex-1 text-sm leading-relaxed text-neutral-800">{item.t}</p>
                              <img src={item.img} alt={item.alt} className="h-24 w-auto flex-none rounded-md" />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="mx-6 mb-8 flex items-start gap-4 rounded-xl bg-[#eef2fb] p-5 sm:mx-8">
                      <span className="mt-0.5 flex-none text-[#14265c]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-8 w-8">
                          <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.44-.24-2.827-.684-4.122a.75.75 0 0 0-.722-.516 11.209 11.209 0 0 1-7.878-3.079ZM15.75 10.5a.75.75 0 0 0-1.28-.53l-3.72 3.72-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 0 0 .22-.53Z" clipRule="evenodd" />
                        </svg>
                      </span>
                      <div>
                        <p className="text-base font-bold text-[#14265c]">Proper crating keeps everyone safe.</p>
                        <p className="mt-1 text-sm text-neutral-700">Thank you for helping us ensure safe and secure transport.</p>
                      </div>
                    </div>

                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
        </>
    );
};

export default CheckOutAddress;
